// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-module--layout--WT_lX","container":"layout-module--container--zLeA4"};